import { Box, Toolbar } from '@mui/material'
import React from 'react'

import { GeotokenSelectBox, ListVariantButton } from '../../Components'

const ListHeader: React.FC = () => {
  return (
    <Toolbar>
      <Box display="flex" flexGrow={1}>
        <ListVariantButton />
        <GeotokenSelectBox />
      </Box>
    </Toolbar>
  )
}

export default ListHeader
